import { callAuthorizedGraphQLEndpoint } from '../../../../../../../Module/graphQL'

const updateRestrictedMissionType = async input => {
  const query = `mutation updateUserData($input: UpdateUserInput!){
           updateUserData(input: $input){
               user{
                id
                restrictedMissionType
               } 
            }
        }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const getTeamLeaderSpiesData = queryVars => {
  const query = `
    query (
      $cityId: ID!,
      $statuses: [UserStatusEnum!],
      $tlId: ID!
    ) {
      getLinkedSpy(tlId: $tlId){
        id
        firstName
        lastName
      }
      city(id: $cityId){
        spies(
          statuses: $statuses
        ){
          nodes {
            id
            firstName
            lastName
          }
        }
      }
    }
  `

  return callAuthorizedGraphQLEndpoint(query, queryVars)
}

const createOrUpdateLinkedSpy = async input => {
  const query = `mutation createOrUpdateLinkedSpy($input: CreateOrUpdateLinkedSpyInput!){
           createOrUpdateLinkedSpy(input: $input){
               success
            }
        }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

const updateUserSettings = async input => {
  const query = `mutation updateUserSettings($input: UpdateUserSettingsInput!){
           updateUserSettings(input: $input){
                  id
                  userId
                  tlaWeeklyMissionsLimit
                  baWeeklyMissionsLimit
            }
        }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}
export {
  updateRestrictedMissionType,
  getTeamLeaderSpiesData,
  createOrUpdateLinkedSpy,
  updateUserSettings,
}
